// Algorithm families in report order (quantum-vulnerable → quantum-safe) with a stable
// color per family. Classical/broken families use warm colors; PQC families use greens.
export const FAMILIES: { label: string; color: string; test: RegExp }[] = [
  { label: 'RSA', color: '#C22221', test: /rsa/i },
  { label: 'ECC (ECDSA/ECDH)', color: '#e8734f', test: /ec(dsa|dh)|ecc|secp|p-?(256|384|521)|prime256/i },
  { label: 'Diffie-Hellman', color: '#f59e0b', test: /(^|[^a-z])dh([^a-z]|$)|diffie/i },
  { label: '3DES / legacy', color: '#eab308', test: /3des|des|rc4|md5|sha-?1|blowfish/i },
  { label: 'AES', color: '#254F71', test: /aes/i },
  { label: 'ML-KEM', color: '#22c55e', test: /ml-?kem|kyber/i },
  { label: 'ML-DSA', color: '#10b981', test: /ml-?dsa|dilithium/i },
  { label: 'SLH-DSA', color: '#0ea5e9', test: /slh-?dsa|sphincs/i },
]

export const OTHER_FAMILY = { label: 'Other', color: '#94a3b8' }

// classify returns the index into FAMILIES, or -1 for Other.
export function classify(algorithm: string): number {
  return FAMILIES.findIndex((f) => f.test.test(algorithm || ''))
}

// familyOf returns the matched family (label + color), or the Other fallback.
export function familyOf(algorithm: string): { label: string; color: string } {
  const idx = classify(algorithm)
  return idx >= 0 ? { label: FAMILIES[idx].label, color: FAMILIES[idx].color } : OTHER_FAMILY
}
